module.exports = __webpack_public_path__ + "img/typehoon32_all.fb089159.png";